module.exports = __webpack_public_path__ + "static/reports-insights-2d7a53e28aa2d52b69486d79f88e4093.svg";